import { createFileRoute, redirect } from '@tanstack/react-router'

import { AppShell } from '@/widgets/app-shell/app-shell'

export const Route = createFileRoute('/_authed')({
  /**
   * beforeLoad é SÍNCRONO de propósito: roda a cada navegação, e renovação de
   * token é responsabilidade do automaticSilentRenew + da camada http, não da
   * navegação. Um await aqui atrasaria toda troca de rota.
   *
   * O status já está resolvido: bootstrapAuth() roda antes do createRoot.
   */
  beforeLoad: ({ context, location }) => {
    if (context.auth.status === 'misconfigured') {
      // Token válido, realm incompleto. Mandar para a API seria colecionar 401
      // mudos; a tela de config-error diz qual mapper falta.
      throw redirect({ to: '/auth/config-error' })
    }
    if (context.auth.status !== 'authenticated') {
      throw redirect({ to: '/auth/login', search: { redirect: location.href } })
    }
  },
  component: AppShell,
})
